// LandingUnified — the warm, holistic main entry point at `/` (replaces
// PathChooser as the front door). Speaks to both ends of life — dementia
// & kids — together, then splits visitors into demos, then leads them down
// to the charity workup and a soft "register your interest" prompt.
//
// Order is deliberate:
//   Hero (warm both-version intro)
//   Lea's story (with family-at-table backdrop)
//   Product family (all 3 tablets together — "not another photo frame")
//   Reminiscence 101 (neuroscience credibility)
//   Two-ends demos (split — John & Ella, leading into the demos)
//   How it works
//   Every life (lifetime arc reinforcement)
//   Packaging showcase
//   Pricing
//   Charity workup (give-back architecture)
//   Interest register (soft, no signup pressure)
//   Footer
import { SiteNav } from "../components/SiteNav";
import { HeroUnified } from "../components/sections/HeroUnified";
import { LeaStory } from "../components/sections/LeaStory";
import { LeaSalonStories } from "../components/sections/LeaSalonStories";
import { ProductFamily } from "../components/sections/ProductFamily";
import { Reminiscence101 } from "../components/sections/Reminiscence101";
import { Problem } from "../components/sections/Problem";
import { KidsEditionIntro } from "../components/sections/KidsEditionIntro";
import { ProblemKids } from "../components/sections/ProblemKids";
import { TwoEndsDemos } from "../components/sections/TwoEndsDemos";
import { HowItWorks } from "../components/sections/HowItWorks";
import { LanguageCapability } from "../components/sections/LanguageCapability";
import { EveryLife } from "../components/sections/EveryLife";
import { PackagingShowcase } from "../components/sections/PackagingShowcase";
import { Pricing } from "../components/sections/Pricing";
import { FlexibilityOptions } from "../components/sections/FlexibilityOptions";
import { FeaturesAtoZ } from "../components/sections/FeaturesAtoZ";
import { CharityWorkup } from "../components/sections/CharityWorkup";
import { LifecycleEditions } from "../components/sections/LifecycleEditions";
import { InterestRegister } from "../components/sections/InterestRegister";
import { Footer } from "../components/sections/Footer";
import { useLenisScroll } from "../lib/useLenisScroll";

export default function LandingUnified() {
    useLenisScroll();
    return (
        <div className="bg-[#FDFBF7] text-[#2D2B2A]" data-testid="landing-unified-page">
            <SiteNav />
            <main>
                <HeroUnified />
                <LeaStory />
                <LeaSalonStories />
                <ProductFamily />
                <Reminiscence101 />
                <Problem />
                <KidsEditionIntro />
                <ProblemKids />
                <TwoEndsDemos />
                <HowItWorks />
                <LanguageCapability />
                <EveryLife />
                <PackagingShowcase />
                <FeaturesAtoZ />
                <LifecycleEditions />
                <FlexibilityOptions />
                <Pricing />
                <CharityWorkup />
                <InterestRegister />
            </main>
            <Footer />
        </div>
    );
}
